import React, { Component } from 'react';
import { connect } from 'react-redux';
import './header.css';
import SignIn from './user/sign-in';
export class Header extends Component {

    render() {

        return (
            <div className="header">
                <div className="header_logo">
                    <img src='./logo.png' />
                </div>
                <div className='header_toolbar'>
                    <SignIn />
                </div>
            </div>
        );

    }

}

export default connect()(Header);